module.exports = __webpack_public_path__ + "img/yotube_icon.1ed15b31.png";